import {memo} from "react";
import Form from "react-bootstrap/Form";

function Input(props) {
    const {label, placeholder, onChange} = props;
    return (
        <Form.Group controlId="sigin-screen-input" className="sigin-screen-form">
            <p className="sigup-screen-label">
                {label}
            </p>
            <Form.Control 
                placeholder={placeholder}
                type="tel"
                className="sigup-screen-input"
                onChange={(e) => onChange(e.target.value)}
            />
        </Form.Group>
    );
};
export default memo(Input);